import { Alert, Space, Spin, Tree, Typography } from 'antd';
import type { DataNode } from 'antd/es/tree';

import { Axios } from '@app/web-components';

import { useFindProductFamilyById } from '../data';

export type ProductFamilyHierarchyPanelProps = {
  productFamilyId: number;
};

export const ProductFamilyHierarchyPanel = ({ productFamilyId }: ProductFamilyHierarchyPanelProps) => {
  const productFamilyQuery = useFindProductFamilyById({ productFamilyId });

  if (productFamilyQuery.error) {
    return (
      <Alert message="Error" description={Axios.getErrorMessage(productFamilyQuery.error)} type="error" showIcon />
    );
  }

  if (productFamilyQuery.isPending || productFamilyQuery.isFetching) {
    return (
      <Spin tip="Getting data..." style={{ width: '100%' }}>
        <div style={{ height: 50 }} />
      </Spin>
    );
  }

  // convert data to tree view format
  const treeData: DataNode[] = [];
  productFamilyQuery.data?.products.forEach((product) => {
    treeData.push({
      title: (
        <Space>
          <Typography.Text>{product.name}</Typography.Text>
          {product.planningState ? (
            <Typography.Text type="warning">{product.planningState}</Typography.Text>
          ) : undefined}
        </Space>
      ),
      key: 'product_' + product.id,
      children: product.dies.map((die) => ({
        title: (
          <Space>
            <Typography.Text>
              {die.name} ({die.process || 'Undefined'})
            </Typography.Text>
            {die.planningState ? <Typography.Text type="warning">{die.planningState}</Typography.Text> : undefined}
          </Space>
        ),
        key: 'die_' + die.id,
      })),
    });
  });

  return <Tree treeData={treeData} />;
};
